import React from 'react';

const LogoRssSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 2c11 0 20 9 20 20h-3.5c0-9.1-7.4-16.5-16.5-16.5V2zm0 7c7.2 0 13 5.9 13 13h-3.5c0-5.3-4.3-9.6-9.6-9.6V9zm2.6 13C3.2 22 2 20.8 2 19.4c0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6C7.2 20.8 6 22 4.6 22z"
        />
    </svg>
);

LogoRssSvg.displayName = 'LogoRssSvg';
export default LogoRssSvg;
